// This is a placeholder for the IndexInsertService. You should move or import the real service logic here as needed.
export interface UploadedFileInfo {
    file: File;
    status: string;
    disp_status: string;
}

export class IndexInsertService {
    uploadedFileInfo: UploadedFileInfo[] = [];
    timelineStep: number = 0;
    stepTables: any[] = [];
    saveMessage: string = '';
    loadState() {}
    getSectionOptions() { return { subscribe: (cb: any) => cb([]) }; }
    getCalculatedSections(refNum: number) { return { subscribe: (cb: any) => cb([]) }; }
    putSectionDefinitors(refNum: number, assignments: any) { return { subscribe: (cb: any) => cb({}) }; }
    addFiles(files: File[]) {}
    clearFiles() {}
    removeFile(file: File) {}
    setStepTable(idx: number, data: any[]) {}
    setSaveMessage(msg: string) {}
}
